import { useState } from 'react'

import { AddBonusesResponse, AddBonusesRequest } from '../model/bonus.model'

import { useAppDepsContext } from '~/core/hooks/useAppDepsContext'

interface StateInterface {
  data?: AddBonusesResponse
  loading: boolean
  error: null | string
}

export default function useAddBonuses() {
  const { bonusService } = useAppDepsContext()

  const [state, setState] = useState<StateInterface>({
    loading: false,
    error: null,
  })

  function addBonuses(body: AddBonusesRequest, subscriptionId: string, brand: string, sub: string) {
    setState({ ...state, loading: true })

    bonusService
      .addBonuses(body, subscriptionId, brand, sub)
      .then((results: AddBonusesResponse) => {
        setState({ ...state, loading: false, data: results })
      })
      .catch((error: string) => {
        setState({ ...state, loading: false, error })
      })
  }

  return {
    state,
    responsesByBonus: state.data?.items || [],
    addBonuses,
  }
}
